import { COOKIE_BROADBAND_SEARCH } from '@/constants/cookies';
import { PRODUCT_BROADBAND } from '@/constants/products';
import { getBroadbandSearch } from '@/graphql/queries/broadband';
import { getProviders } from '@/graphql/queries/shared/institution';
import lang from '@/lang/middleware/products/broadband';

export default async ({ $apolloQuery, app, $cookies, redirect, store }) => {
  const backToSearch = () => redirect(302, app.localePath('/compare-tv-broadband-phone/'));
  const code = $cookies.get(COOKIE_BROADBAND_SEARCH);
  if (!code) return backToSearch();
  await $apolloQuery(getProviders, { product: PRODUCT_BROADBAND }).then(providers => store.commit('providers/setList', providers));
  await $apolloQuery(getBroadbandSearch, { code }).then(search => {
    store.$i18n.mergeLocaleMessage('en', lang.en);
    const title = store.$i18n.t('results.title');
    store.commit('search/set', search);
    store.commit('pageContent/setHead', { title });
  }).catch(_ => backToSearch());
};
